import { render } from "./Menu.vue?vue&type=template&id=3a0a9d6c&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=3a0a9d6c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3a0a9d6c"

export default script